import { Heading } from '@elevationscu/ui-component-lib';
import { useMediaQuery } from 'react-responsive';
import { BusinessCard } from './BusinessCard';
import './TitleBanner.scss';

export function TitleBanner({
  loDetails,
}) {
  const isMobile = useMediaQuery({ query: '(max-width: 576px)' });

  return (
    isMobile
      ? (
        // Mobile view
        <div className="mobileMain hide-on-print">
          <div className="mobileHeading">
            <span id="mobileTitleBannerHeading">
              <Heading element="h3" size={3} className="dataFormHeader" data-test-id="mobile_title_banner_heading">
                Welcome to the Elevations Refinance Assistant
              </Heading>
            </span>
          </div>
          <BusinessCard loDetails={loDetails} />
        </div>
      )
      : (
        // This is Desktop View
        <div className="hide-on-print">
          <div className="titleBanner">
            <div className="titleBannerHeading">
              <Heading element="h3" size={3} className="dataFormHeader" data-test-id="desktop_title_banner_heading">
                Is now the time for you to refinance?
              </Heading>
              <p data-test-id="desktop_title_banner_subheading">
                Get started by entering an address below and we will provide you some options to evaluate. Just click apply or reach out!
              </p>
            </div>
          </div>
          <BusinessCard loDetails={loDetails} />
        </div>
      )
  );
}
